"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTV_KEY = {
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    AD: 'AD',
    BACK: 'BACK',
    BLUE: 'BLUE',
    DELETE: 'DELETE',
    DOWN: 'DOWN',
    ENTER: 'ENTER',
    FF: 'FF',
    GREEN: 'GREEN',
    HELP: 'HELP',
    INFO: 'INFO',
    L3: 'L3',
    LEFT: 'LEFT',
    PAUSE: 'PAUSE',
    PLAY: 'PLAY',
    PLAY_PAUSE: 'PLAY_PAUSE',
    RED: 'RED',
    RW: 'RW',
    RIGHT: 'RIGHT',
    SEARCH: 'SEARCH',
    SKIP_NEXT: 'SKIP_NEXT',
    SKIP_PREV: 'SKIP_PREV',
    START: 'START',
    STOP: 'STOP',
    SUBTITLES: 'SUBTITLES',
    UNKNOWN: 'UNKNOWN',
    Y: 'Y',
    YELLOW: 'YELLOW',
    UP: 'UP',
    CHANNEL_UP: 'CHANNEL_UP',
    CHANNEL_DOWN: 'CHANNEL_DOWN',
    SHORTCUT_1: 'SHORTCUT_1',
    SHORTCUT_2: 'SHORTCUT_2',
    SHORTCUT_3: 'SHORTCUT_3',
    SHORTCUT_4: 'SHORTCUT_4',
    SHORTCUT_5: 'SHORTCUT_5',
    SHORTCUT_6: 'SHORTCUT_6',
    SHORTCUT_7: 'SHORTCUT_7',
    SHORTCUT_8: 'SHORTCUT_8',
    SHORTCUT_9: 'SHORTCUT_9',
    INSTANT_REPLAY: 'INSTANT_REPLAY',
};
function lookupCTVKeysForKeyCode(keyMap, key) {
    var keySymbols = [];
    for (var ctvKey in keyMap) {
        var nativeKeyCodes = keyMap[ctvKey];
        if (nativeKeyCodes.indexOf(key) !== -1) {
            keySymbols.push(ctvKey);
        }
    }
    if (keySymbols.length === 0) {
        keySymbols.push(exports.CTV_KEY.UNKNOWN);
    }
    return keySymbols;
}
exports.lookupCTVKeysForKeyCode = lookupCTVKeysForKeyCode;
